import React from 'react';
import {useComponent} from '../component-library';
import {DisclaimerKind} from '../types';
import {useDisclaimer} from '../utils/use-disclaimer';
export interface ExternallyRenderedDisclaimerReferenceProps {
  readonly text: string;
  disclaimerReferenceLabelTranslation: string | undefined;
  closeButtonLabel: string;
}

export function ExternallyRenderedDisclaimerReference({
  text,
  disclaimerReferenceLabelTranslation,
  closeButtonLabel,
}: ExternallyRenderedDisclaimerReferenceProps): JSX.Element | null {
  const referenceProps = useDisclaimer(
    text,
    DisclaimerKind.ExternallyRendered,
    disclaimerReferenceLabelTranslation,
    closeButtonLabel
  );

  const DisclaimerReference = useComponent('DisclaimerReference');

  return <DisclaimerReference {...referenceProps} />;
}
